import DrawerButton from "components/ui/DrawerButton";
import { useMutation } from "lib/apollo/client";
import { toast } from "sonner";
import Icon from "hardcover-ui/components/Icon";
import trash from "icons/solid/trash.svg";
import { deleteReadingJournalEntries } from "features/ReadingJournal/queries/deleteReadingJournalEntries";
import { PageSerializersBooksLayout } from "types/serializers";
import { router } from "@inertiajs/react";

export default function DeleteAllJournalEntriesButton({
  book,
}: {
  book: PageSerializersBooksLayout;
}) {
  const [sendDelete, { loading }] = useMutation(deleteReadingJournalEntries);

  const deleteJournalEntry = async (event: any) => {
    event.preventDefault();
    if (confirm("Are you sure you want to delete all journal entries?")) {
      sendDelete({
        variables: {
          book_id: book.id,
        },
      })
        .then(() => {
          router.reload({ only: ["journals"] });
          toast.success("Journal entries deleted successfully");
        })
        .catch(() => {
          toast.error("Failed to delete journal entries. Please try again");
        });
    }
  };

  return (
    <DrawerButton isLoading={loading} onClick={deleteJournalEntry}>
      <Icon icon={trash} className="mr-2" />
      Delete All Entries
    </DrawerButton>
  );
}
